module.exports = __webpack_public_path__ + "static/media/Email05-Image.86c0953a.jpg";